import {
  gridSizeMdLg10,
  gridSizeMdLg12,
  gridSizeMdLg6,
  texto,
  TipoContribuyenteRucChoice,
  TipoIdentificacionEnumChoice,
} from "@/shared";
import {
  CustomTextField,
  CustomTextFieldNumberComponente,
  SampleCheckbox,
  SingleButton,
  TabTextLabel,
} from "@/shared/components/ui";
import { TiposTextFieldNumberEnum } from "@/shared/components/ui/CustomTextFieldNumberComponente";
import ImageUploadComponente from "@/shared/components/ui/UploadImage/ImageUploadComponente";
import {
  IDataProspecto,
  IFormPreventa,
  PaymentMethodEnum,
  TipoSolicitudesEnum,
} from "@/shared/interfaces";
import { Edit } from "@mui/icons-material";
import MarkunreadIcon from "@mui/icons-material/Markunread";
import PendingIcon from "@mui/icons-material/Pending";
import {
  Alert,
  AlertTitle,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { Controller, UseFormReturn } from "react-hook-form";
import OtpInput from "react-otp-input";
interface TabDocumentosPreventaProps {
  dataProspecto: IDataProspecto;
  editSupervisor: boolean;
  form: UseFormReturn<IFormPreventa, any, IFormPreventa>;
  imgCedulaFrontal: File | null;
  setImgCedulaFrontal: React.Dispatch<React.SetStateAction<File | null>>;
  imgCedulaReverso: File | null;
  setImgCedulaReverso: React.Dispatch<React.SetStateAction<File | null>>;
  imgCuentaBancaria: File | null;
  setImgCuentaBancaria: React.Dispatch<React.SetStateAction<File | null>>;
  imgTarjeta: File | null;
  setImgTarjeta: React.Dispatch<React.SetStateAction<File | null>>;
  imgRUC: File | null;
  setImgRUC: React.Dispatch<React.SetStateAction<File | null>>;
  imgRUCNombramiento: File | null;
  setImgRUCNombramiento: React.Dispatch<React.SetStateAction<File | null>>;
  handleEstadoCodOTP: () => Promise<void>;
  handleGenerarOTP: () => Promise<void>;
  openOtp: boolean;
  handleCambiarCelular: (value: string) => Promise<void>;
  valueOtp: string;
  setValueOtp: React.Dispatch<React.SetStateAction<string>>;
  countdown: number;
  handleVerificarCodOTP: () => Promise<void>;
  handleCancelarCodOTP: () => Promise<void>;
  handleEnviarSolicitudOTP: () => Promise<void>;
  handleValidarTipoVenta: string;
  valorRestriccionCel?: any;
}
export default function TabDocumentosPreventa({
  dataProspecto,
  editSupervisor,
  form,
  imgCedulaFrontal,
  setImgCedulaFrontal,
  imgCedulaReverso,
  setImgCedulaReverso,
  imgCuentaBancaria,
  setImgCuentaBancaria,
  imgTarjeta,
  setImgTarjeta,
  imgRUC,
  setImgRUC,
  imgRUCNombramiento,
  setImgRUCNombramiento,
  handleEstadoCodOTP,
  handleGenerarOTP,
  openOtp,
  handleCambiarCelular,
  valueOtp,
  setValueOtp,
  countdown,
  handleVerificarCodOTP,
  handleCancelarCodOTP,
  handleEnviarSolicitudOTP,
  handleValidarTipoVenta,
  valorRestriccionCel
}: TabDocumentosPreventaProps) {
  const {
    formState: { errors },
  } = form;

  return (
    <Grid container spacing={3} justifyContent={"end"}>
      <Grid item {...gridSizeMdLg12}>
        {false && (
          <Grid item {...gridSizeMdLg12}>
            <Alert
              severity="info"
              onClose={() => {
                //setErrorCedula(false);
              }}
            >
              <AlertTitle>Información</AlertTitle>
              <Grid container>
                <Grid item xs={12}>
                  <span>{texto.error_imagen_cedula}</span>
                </Grid>
              </Grid>
            </Alert>
          </Grid>
        )}
      </Grid>

      <Grid item {...gridSizeMdLg6}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <TabTextLabel
              text={`${texto.documento_personal}`}
              mt={0}
              pb={2}
              pl={0}
              pt={0}
            />
          </Grid>

          {!form.watch("requiere_contrato_fisico") &&
            !form.watch("pre_requiere_contrato_fisico") && (
              <Grid item {...gridSizeMdLg12}>
                <Controller
                  name="codigo_dactilar"
                  control={form.control}
                  defaultValue=""
                  render={({ field, fieldState }) => (
                    <FormControl fullWidth error={!!fieldState.error}>
                      <TextField
                        {...field}
                        label="Código Dactilar"
                        variant="outlined"
                        fullWidth
                        required
                        placeholder="Ej: AB12CD3456"
                        inputProps={{ maxLength: 10 }}
                        onChange={(e) => {
                          const filtered = e.target.value
                            .toUpperCase()
                            .replace(/[^A-Z0-9]/g, "")
                            .slice(0, 10);
                          field.onChange(filtered);
                        }}
                        error={!!fieldState.error}
                        helperText={
                          fieldState.error?.message ??
                          "Código dactilar del firmante (10 caracteres alfanuméricos)"
                        }
                      />
                    </FormControl>
                  )}
                />
              </Grid>
            )}

          <Grid item {...gridSizeMdLg6}>
            <ImageUploadComponente
              buttonText={texto.cargar_cedula}
              selectedImage={imgCedulaFrontal}
              setSelectedImage={setImgCedulaFrontal}
              idInput={"cedula-frontal"}
              imageUrl={
                form.getValues().url_foto_identificacion_delantera ?? ""
              }
              ///* edit
              endIcon={editSupervisor && <Edit />}
              enablePreview={true}
              onClickTrash={() => {
                form.setValue("url_foto_identificacion_delantera", "");
              }}
            />
          </Grid>

          <Grid item {...gridSizeMdLg6}>
            <ImageUploadComponente
              buttonText={texto.cargar_cedula_reverso}
              selectedImage={imgCedulaReverso}
              setSelectedImage={setImgCedulaReverso}
              idInput={"cedula-reverso"}
              imageUrl={
                form.getValues().url_foto_identificacion_posterior ?? ""
              }
              ///* edit
              endIcon={editSupervisor && <Edit />}
              enablePreview={true}
              onClickTrash={() => {
                form.setValue("url_foto_identificacion_posterior", "");
              }}
            />
          </Grid>

          {form.getValues().forma_pago === PaymentMethodEnum.DEBITO && (
            <Grid item {...gridSizeMdLg12}>
              <ImageUploadComponente
                buttonText={texto.respaldo_pago}
                selectedImage={imgCuentaBancaria}
                setSelectedImage={setImgCuentaBancaria}
                idInput={"respaldo-preventa"}
                imageUrl={form.getValues().url_foto_cuenta_bancaria ?? ""}
                ///* edit
                endIcon={editSupervisor && <Edit />}
                enablePreview={true}
                onClickTrash={() => {
                  form.setValue("url_foto_cuenta_bancaria", "");
                }}
              />
            </Grid>
          )}

          {form.getValues().forma_pago == PaymentMethodEnum.TARJETA && (
            <Grid item {...gridSizeMdLg12}>
              <ImageUploadComponente
                buttonText={texto.foto_tarjeta}
                selectedImage={imgTarjeta}
                setSelectedImage={setImgTarjeta}
                idInput={"tarjeta-preventa"}
                imageUrl={form.getValues().url_foto_tarjeta ?? ""}
                ///* edit
                canDelete={editSupervisor}
                endIcon={editSupervisor && <Edit />}
                enablePreview={true}
                onClickTrash={() => {
                  form.setValue("url_foto_tarjeta", "");
                }}
              />
            </Grid>
          )}

          {dataProspecto?.tipo_identificacion ===
            TipoIdentificacionEnumChoice.RUC && (
              <>
                <Grid
                  item
                  {...gridSizeMdLg12}
                  className={
                    editSupervisor
                      ? "editSupervisor-disabled"
                      : "editSupervisor-enabled"
                  }
                >
                  <ImageUploadComponente
                    buttonText={"Cargar RUC"}
                    selectedImage={imgRUC}
                    setSelectedImage={setImgRUC}
                    idInput={"ruc-preventa"}
                    imageUrl={form.getValues().url_foto_ruc ?? ""}
                  />
                </Grid>

                {dataProspecto.tipo_contribuyente !==
                  TipoContribuyenteRucChoice.PERSONA_NATURAL && (
                    <Grid
                      item
                      {...gridSizeMdLg12}
                      className={
                        editSupervisor
                          ? "editSupervisor-disabled"
                          : "editSupervisor-enabled"
                      }
                    >
                      <ImageUploadComponente
                        buttonText={"Cargar Nombramiento"}
                        selectedImage={imgRUCNombramiento}
                        setSelectedImage={setImgRUCNombramiento}
                        idInput={"ruc-nombramiento"}
                        imageUrl={form.getValues().url_foto_nombramiento ?? ""}
                      />
                    </Grid>
                  )}
              </>
            )}
        </Grid>
        <Typography variant="body1">
          {`NOTA: Por favor cargar las fotos sin rotaciones y en una resolución aceptable para reconocimiento de caracteres automático`}
        </Typography>
      </Grid>

      <Grid
        item
        {...gridSizeMdLg6}
        className={
          editSupervisor ? "editSupervisor-disabled" : "editSupervisor-enabled"
        }
      >
        <Grid container spacing={3}>
          <Grid item {...gridSizeMdLg12}>
            <TabTextLabel text={"Generar OTP"} mt={0} pb={2} pl={0} pt={0} />
          </Grid>
          {!openOtp && (
            <>
              <CustomTextFieldNumberComponente
                size={gridSizeMdLg6}
                disabled={false}
                type={TiposTextFieldNumberEnum.CELULAR}
                label={texto.celular}
                error={errors.celular}
                helperText={errors.celular?.message}
                control={form.control}
                defaultValue={
                  form.getValues().celular || dataProspecto?.celular
                }
                name="celular"
                onChangeValue={async (e) => handleCambiarCelular(e)}
                customRestriccionCelular={valorRestriccionCel}
                soloAdvertenciaRestriccion={true}
              />

              {/* <CustomTextFieldNumberComponente
                size={gridSizeMdLg12}
                type={TiposTextFieldNumberEnum.CELULAR}
                label={texto.celular}
                error={errors.celular}
                helperText={errors.celular?.message}
                control={form.control}
                name="celular"
                
                defaultValue={form.getValues().celular || ''}
                customRestriccionCelular={valorRestriccionCel}
              /> */}

              <Grid item {...gridSizeMdLg6}>
                <Tooltip title="Comprobar si es valido" placement="top">
                  <IconButton onClick={async () => handleEstadoCodOTP()}>
                    <PendingIcon
                      color={"primary"}
                      style={{ fontSize: "30px" }}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Enviar Codigo OTP" placement="top">
                  <IconButton
                    onClick={async () => {
                      handleGenerarOTP();
                    }}
                  >
                    <MarkunreadIcon
                      color="warning"
                      style={{ fontSize: "30px" }}
                    />
                  </IconButton>
                </Tooltip>
              </Grid>
            </>
          )}

          {openOtp && (
            <Grid item {...gridSizeMdLg12}>
              <Grid container spacing={2}>
                {/* -------- text -------- */}
                <Grid item {...gridSizeMdLg12}>
                  <Typography variant="body1">
                    {`Se ha enviado un mensaje SMS con un código de 6 dígitos al cliente con el número ${form.getValues().celular
                      }.`}
                  </Typography>
                </Grid>

                <Grid item {...gridSizeMdLg12}>
                  <Grid container justifyContent={"space-between"}>
                    <Grid item>
                      <Typography variant="body1">
                        Ingresar el codigo
                      </Typography>
                    </Grid>
                    <Grid item>
                      <Typography variant="body1">
                        {`Tiempo restante: ${Math.floor(countdown / 60)}:${countdown % 60
                          } minutos`}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item {...gridSizeMdLg10}>
                  <div
                    style={{
                      display: "flex",
                    }}
                  >
                    <OtpInput
                      containerStyle={{
                        height: "125px",
                      }}
                      inputStyle={{
                        height: "50px",
                        width: "50px",
                        borderRadius: "5px",
                        border: "0.5px solid gray",
                        fontSize: "25px",
                      }}
                      value={valueOtp}
                      onChange={setValueOtp}
                      numInputs={6}
                      //inputType='number'
                      renderSeparator={<span style={{ padding: "5px" }} />}
                      renderInput={(props) => <input {...props} />}
                    />
                  </div>
                </Grid>

                <Grid item {...gridSizeMdLg6}>
                  <SingleButton
                    width="100%"
                    maxHeight="100px"
                    color={"success"}
                    variant="outlined"
                    label="Verificar Código"
                    onClick={async () => {
                      handleVerificarCodOTP();
                    }}
                  />
                </Grid>

                <Grid item {...gridSizeMdLg6}>
                  <SingleButton
                    width="100%"
                    maxHeight="100px"
                    color={"error"}
                    variant="outlined"
                    label="Cancelar"
                    onClick={async () => handleCancelarCodOTP()}
                  />
                </Grid>

                <Grid item {...gridSizeMdLg12}>
                  <SingleButton
                    width="100%"
                    maxHeight="100px"
                    variant="outlined"
                    color={"warning"}
                    label="Solicitar Verificación a Supervisor"
                    onClick={async () => handleEnviarSolicitudOTP()}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}

          {handleValidarTipoVenta == TipoSolicitudesEnum.HOGAR && (
            <Grid item {...gridSizeMdLg12}>
              <SampleCheckbox
                label="Requiere contratos físicos"
                name="pre_requiere_contrato_fisico"
                control={form.control}
                defaultValue={!!form.getValues().pre_requiere_contrato_fisico}
                size={gridSizeMdLg12}
                textNote="NOTA: Esta solicitud se envia al supervisor de venta"
              />
            </Grid>
          )}

          {dataProspecto?.tipo_identificacion ===
            TipoIdentificacionEnumChoice.RUC &&
            dataProspecto?.identificacion?.endsWith("001") &&
            (form.watch("tipo_contribuyente") ||
              dataProspecto?.tipo_contribuyente) ===
            TipoContribuyenteRucChoice.PERSONA_NATURAL && (
              <Grid item {...gridSizeMdLg12}>
                <SampleCheckbox
                  label="Requiere autorización de débito/tarjeta sin RUC"
                  name="pre_autorizacion_sin_ruc"
                  control={form.control}
                  defaultValue={!!form.getValues().pre_autorizacion_sin_ruc}
                  size={gridSizeMdLg12}
                  textNote="NOTA: La identificación en documentos de autorización se mostrará sin los últimos 3 dígitos (001)"
                />
              </Grid>
            )}
        </Grid>
      </Grid>
    </Grid>
  );
}
